import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`npm exists to facilitate sharing code, by making it easy for
JavaScript module developers to publish and distribute packages.`}</p>
    <p>{`npm is a piece of technology, but more importantly, it is a community.`}</p>
    <p>{`We believe that our mission is best served in an environment that is
friendly, safe, and accepting; free from intimidation or harassment.`}</p>
    <p>{`Towards this end, certain behaviors and practices will not be
tolerated.`}</p>
    <h2>{`tl;dr`}</h2>
    <ul>
      <li parentName="ul">{`Be respectful.`}</li>
      <li parentName="ul">{`We're here to help`}</li>
      <li parentName="ul">{`Abusive behavior is never tolerated.`}</li>
      <li parentName="ul">{`Data published to npm is hosted at the discretion of the service
administrators, and may be removed.`}</li>
      <li parentName="ul">{`Violations of this code may result in swift and permanent expulsion
from the npm community.`}</li>
    </ul>
    <h2>{`Scope`}</h2>
    <p>{`We expect all members of the npm community, including paid and unpaid
agents, administrators, users, and customers of npm, Inc., to abide by
this Code of Conduct at all times in all npm community venues, online
and in person, and in one-on-one communications pertaining to npm
affairs.`}</p>
    <p>{`This policy covers the usage of the npm registry, as well as the npm
website, npm related events, and any other services offered by or on
behalf of npm, Inc. (collectively, the "Service").  It also applies to
behavior in the context of the npm Open Source project communities,
including but not limited to public GitHub repositories, IRC channels,
social media, mailing lists, and public events.`}</p>
    <p>{`This Code of Conduct is in addition to, and does not in any way
nullify or invalidate, any other terms or conditions related to use of
the Service.`}</p>
    <p>{`The definitions of various subjective terms such as "discriminatory",
"hateful", or "confusing" will be decided at the sole discretion of
the npm abuse team.`}</p>
    <h2>{`Friendly Harassment-Free Space`}</h2>
    <p>{`We are committed to providing a friendly, safe and welcoming
environment for all, regardless of gender identity, sexual
orientation, ability, ethnicity, religion, age, physical
appearance, body size, race, or similar personal characteristics.`}</p>
    <p>{`We ask that you please respect that people have differences of opinion
regarding technical choices, and that every design or implementation
choice carries a trade-off and numerous costs.  There is seldom a
single right answer.  A difference of technology preferences is not a
license to be rude.`}</p>
    <p>{`Disputes over package rights must be handled respectfully, according
to the terms described in the `}<a parentName="p" {...{
        "href": "/policies/disputes"
      }}>{`Disputes Policy`}</a>{`.
There is never a good reason to be rude over package name disputes.`}</p>
    <p>{`Any spamming, trolling, flaming, baiting, or other attention-stealing
behavior is not welcome, and will not be tolerated.`}</p>
    <p>{`Harassing other users of the Service is never tolerated, whether via
public or private media.`}</p>
    <p>{`Avoid using offensive or harassing package names, nicknames, or other
identifiers that might detract from a friendly, safe, and welcoming
environment for all.`}</p>
    <p>{`Harassment includes, but is not limited to: harmful or prejudicial
verbal or written comments related to gender identity, sexual
orientation, ability, ethnicity, religion, age, physical
appearance, body size, race, or similar personal characteristics;
inappropriate use of nudity, sexual images, and/or sexually explicit
language in public spaces; threats of physical or non-physical harm;
deliberate intimidation, stalking or following; harassing photography
or recording; sustained disruption of talks or other events;
inappropriate physical contact; and unwelcome sexual attention.`}</p>
    <h2>{`Acceptable Use`}</h2>
    <p>{`The Service administrators reserve the right to make judgment calls
about what is and isn't appropriate in published packages, package names,
user and organization names, and other public content. Package that
violates the npm Service's
`}<a parentName="p" {...{
        "href": "/policies/open-source-terms#acceptable-use"
      }}>{`Acceptable Use`}</a>{`
rules including its
`}<a parentName="p" {...{
        "href": "/policies/open-source-terms#acceptable-content"
      }}>{`Acceptable Content`}</a>{`
rules will be deleted, at the discretion of npm.`}</p>
    <h2>{`Reporting Violations of this Code of Conduct`}</h2>
    <p>{`Please select the method of contact you think is most appropriate for
the form of violation:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`For urgent security issues, please open a ticket at `}<a parentName="p" {...{
            "href": "https://npmjs.com/support"
          }}>{`https://npmjs.com/support`}</a>{`.
Requests to un-publish packages are not usually considered urgent security
issues, as it is possible to `}<a parentName="p" {...{
            "href": "/policies/unpublish"
          }}>{`un-publish a package`}</a>{`
within 24 hours of its first publish. Any publicly published package
is `}<a parentName="p" {...{
            "href": "http://blog.npmjs.org/post/101934969510/oh-no-i-accidentally-published-private-data-to"
          }}>{`immediately replicated to thousands of third-party mirrors`}</a>{`,
so any confidential information contained in a package should be considered
immediately compromised.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`If you believe someone is harassing you or is demonstrating
some other form of malicious or inappropriate behavior, open a support
ticket at `}<a parentName="p" {...{
            "href": "https://npmjs.com/support"
          }}>{`https://npmjs.com/support`}</a>{`. If this is the initial report of a problem,
please include as much detail as possible. It is easiest for us
to address issues when we have more context.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`If you have concerns about a potential copyright violation,
please refer to our `}<a parentName="p" {...{
            "href": "/policies/dmca"
          }}>{`Copyright Policy`}</a>{`
and take action as recommended by that policy.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`If you think a package or other content is "squatting" on a name,
follow the process described in the
`}<a parentName="p" {...{
            "href": "/policies/disputes"
          }}>{`Disputes Policy`}</a>{`.`}</p>
      </li>
    </ul>
    <p>{`For any other issues, or if in doubt, `}<a parentName="p" {...{
        "href": "https://npmjs.com/support"
      }}>{`contact support`}</a>{`.`}</p>
    <h2>{`Consequences`}</h2>
    <p>{`All content published to the Service, including user account
credentials, is hosted at the sole discretion of the npm
administrators.`}</p>
    <p>{`Unacceptable behavior from any community member, including sponsors,
employees, customers, or others with decision-making authority, will
not be tolerated.`}</p>
    <p>{`Anyone asked to stop unacceptable behavior is expected to comply
immediately.`}</p>
    <p>{`If a community member engages in unacceptable behavior, the npm
administrators may take any action they deem appropriate, up to and
including a temporary ban or permanent expulsion from the community
without warning (and without refund in the case of a paid event or
service).`}</p>
    <h2>{`Addressing Grievances`}</h2>
    <p>{`If you feel you have been falsely or unfairly accused of violating
this Code of Conduct, you should notify npm, Inc.  We will do our best
to ensure that your grievance is handled appropriately.`}</p>
    <p>{`In general, we will choose the course of action that we judge as being
most in the interest of fostering a safe and friendly community.`}</p>
    <h2>{`Contact Info`}</h2>
    <p>{`Please open a support ticket at `}<a parentName="p" {...{
        "href": "https://npmjs.com/support"
      }}>{`https://npmjs.com/support`}</a>{` if you need to
report a problem or address a grievance related to an abuse report.`}</p>
    <p>{`You are also encouraged to contact us if you are curious about
something that might be "on the line" between appropriate and
inappropriate content.  We are happy to provide guidance to help you
be a successful part of our community.`}</p>
    <h2>{`Changes`}</h2>
    <p>{`This is a living document and may be updated from time to time.
Please refer to the `}<a parentName="p" {...{
        "href": "https://github.com/npm/documentation/blob/main/content/policies/conduct.mdx"
      }}>{`git history for this
document`}</a>{`
to view the changes.`}</p>
    <h2>{`Credit and License`}</h2>
    <p>{`This Code of Conduct borrows heavily from the Stumptown Syndicate
`}<a parentName="p" {...{
        "href": "http://citizencodeofconduct.org/"
      }}>{`Citizen's Code of Conduct`}</a>{`, and the
`}<a parentName="p" {...{
        "href": "https://www.rust-lang.org/conduct.html"
      }}>{`Rust Project Code of
Conduct`}</a>{`.`}</p>
    <p>{`This document may be reused under a `}<a parentName="p" {...{
        "href": "https://creativecommons.org/licenses/by-sa/4.0/"
      }}>{`Creative Commons
Attribution-ShareAlike
License`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      